import type { PlatformAdapter } from './types';
import { webPlatform } from './web';
import { tauriPlatform } from './tauri';

function detectTauri(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return Boolean(
    (window as unknown as { __TAURI_INTERNALS__?: unknown }).__TAURI_INTERNALS__ ||
      (window as unknown as { __TAURI__?: unknown }).__TAURI__,
  );
}

export function getPlatform(): PlatformAdapter {
  return detectTauri() ? tauriPlatform : webPlatform;
}

export type { PlatformAdapter, PlatformKind } from './types';
